// @ts-nocheck
import React from 'react';
import Text from 'components/core/Text';
import { sanitizeRichTextHtml, sanitizeLinkUrl } from 'utils/sanitizeHtml';
import { StyledBar, CloseButton, StyledLink } from './styles';

interface AnnouncementBarProps {
  message: string;
  linkText?: string;
  linkUrl?: string;
  onClose: () => void;
}

const AnnouncementBar: React.FC<AnnouncementBarProps> = ({
  message,
  linkText,
  linkUrl,
  onClose,
}) => {
  const safeUrl = sanitizeLinkUrl(linkUrl);
  return (
    <StyledBar>
      <Text variant="text" align="left" pt={2}>
        {}
        <span dangerouslySetInnerHTML={{ __html: sanitizeRichTextHtml(message) }} />
        {linkText && safeUrl ? (
          <>
            {' '}
            <StyledLink href={safeUrl}>{linkText}</StyledLink>
          </>
        ) : null}
      </Text>
      <CloseButton onClick={onClose} aria-label="Close announcement" />
    </StyledBar>
  );
};

export default AnnouncementBar;
